import { FC, HTMLProps } from 'react';

const FormGroup: FC<HTMLProps<HTMLDivElement>> = ({ children, ...rest }) => (
    <div className="flex flex-col mb-4" {...rest}>
        {children}
    </div>
);

export default FormGroup;